import { z } from "zod";
/** How a user is tracking a title in their personal library. */
export const libraryStatusSchema = z.enum([
    "WATCHING",
    "PLANNED",
    "COMPLETED",
    "ON_HOLD",
    "DROPPED",
]);
export const LIBRARY_STATUS_LABELS = {
    WATCHING: "Watching",
    PLANNED: "Plan to watch",
    COMPLETED: "Completed",
    ON_HOLD: "On hold",
    DROPPED: "Dropped",
};
/** Normalised release format. A provider's own `kind`/`type` is mapped onto this. */
export const animeTypeSchema = z.enum([
    "TV",
    "MOVIE",
    "OVA",
    "ONA",
    "SPECIAL",
    "MUSIC",
    "UNKNOWN",
]);
/** Normalised airing state. */
export const animeAiringSchema = z.enum([
    "AIRING",
    "FINISHED",
    "UPCOMING",
    "UNKNOWN",
]);
export const animeSeasonSchema = z.enum(["winter", "spring", "summer", "fall"]);
/** Sort options exposed by the browse endpoint. */
export const animeOrderBySchema = z.enum([
    /** Popular new titles first: popularity weighed by age (see CatalogService.refreshFreshness). */
    "fresh",
    "score",
    "popularity",
    "rank",
    "title",
    "start_date",
    "episodes",
]);
//# sourceMappingURL=enums.js.map